import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import GraveResultCard from '../../../../../containers/Search/atoms/GraveResultCard';
import AddGraveImage from '../../../../../img/AddGraveImage.svg';
import NoneGravesImage from '../../../../../img/NoneGravesImage.svg';

const Content = (props) => {
  const searchInput = props.searchInputValue || '';

  return (
    <>
      {props.list && props.list.length === 0 ? (
        <>
          <div className="municipality-not-found">
            <img src={NoneGravesImage} alt="not-found" style={{ width: '100%' }} />
            <span className="search-graves_none-text">
              <FormattedMessage id="no_results" />{' '}
              <span>{searchInput.length > 0 ? `"${searchInput}"` : ''}</span>
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Link to="/create_grave" className="no-grave-found-link">
              <img loading="lazy" src={AddGraveImage} alt="Opprett ny grav" />
              <span>
                <FormattedMessage id="create_new_grave" />
              </span>
            </Link>
          </div>
        </>
      ) : (
        <div className="municipality-search-content">
          {props.list &&
            props.list.map((item) => {
              return <GraveResultCard grave={item} style={{ width: 'auto' }} />;
            })}
        </div>
      )}
    </>
  );
};

export default Content;
